import { render, staticRenderFns } from "./UpgradeList.vue?vue&type=template&id=9c4ff106&scoped=true&"
import script from "./UpgradeList.vue?vue&type=script&lang=js&"
export * from "./UpgradeList.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeList.vue?vue&type=style&index=0&id=9c4ff106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4ff106",
  null
  
)

export default component.exports